import { CursorPaginationParametersRequest } from '@/modules/common/types/pagination-types';

import { ClientStatusDTO } from '../dto/client-status.dto';

/**
 * All active (non-archived) client statuses.
 * Use this when loading clients for selection (e.g. project client dropdowns)
 * to exclude archived clients from results.
 */
export const NON_ARCHIVED_CLIENT_STATUSES: ClientStatusDTO[] = [ClientStatusDTO.ACTIVE];

/**
 * Filter criteria for finding short clients
 * Matches FindShortClientsFilterRequest from swagger
 */
export interface FindShortClientsFilterRequest {
  searchString?: string;
  statuses?: ClientStatusDTO[];
}

/**
 * Request body for POST /api/clients/short/search
 * Matches FindShortClientsRequest from swagger
 */
export interface FindShortClientsRequest {
  filter?: FindShortClientsFilterRequest;
  pagination: CursorPaginationParametersRequest;
}
